const isValidEmail = (email) => email && email.includes('@') && email.includes('.')

const isValidCreate = ({ name, lastName, email, password, role, allAgencies }) => {
  if (!name || !lastName || !email || !password || !role) {
    window.growl.show({ severity: 'error', summary: 'Errore', detail: 'Inserisci tutti i campi' })
    return false
  }
  if (!isValidEmail(email)) {
    window.growl.show({ severity: 'error', summary: 'Errore', detail: 'Inserisci una email valida' })
    return false
  }
  if (role === 'agencyAdmin' && (!allAgencies || !allAgencies.length)) {
    window.growl.show({ severity: 'error', summary: 'Errore', detail: "Seleziona almeno un'agenzia" })
    return false
  }
  return true
}

const isValidUpdate = ({ name, lastName, email, role, allAgencies }) => {
  if (!name || !lastName || !email || !role) {
    window.growl.show({ severity: 'error', summary: 'Errore', detail: 'Inserisci tutti i campi obbligatori' })
    return false
  }
  if (!isValidEmail(email)) {
    window.growl.show({ severity: 'error', summary: 'Errore', detail: 'Inserisci una email valida' })
    return false
  }
  if (role === 'agencyAdmin' && (!allAgencies || !allAgencies.length)) {
    window.growl.show({ severity: 'error', summary: 'Errore', detail: "Seleziona almeno un'agenzia" })
    return false
  }
  return true
}

export const createNewUser = async (userData, service) => {
  if (!isValidCreate(userData)) return false

  try {
    const user = { ...userData, username: userData.email }
    const result = await service.create(user)
    window.growl.show({
      severity: result ? 'success' : 'error',
      summary: 'Creazione utente',
      detail: result ? 'Utente creato correttamente' : 'Creazione non andata a buon fine'
    })
    return !!result
  } catch (err) {
    window.growl.show({
      severity: 'error',
      summary: 'Errore',
      detail: err?.message || 'Creazione non andata a buon fine'
    })
    return false
  }
}

export const updateUser = async (id, userData, service) => {
  if (!isValidUpdate(userData)) return false

  try {
    const payload = { ...userData }
    if (!payload.password) delete payload.password
    const result = await service.patch(id, payload)
    window.growl.show({
      severity: result ? 'success' : 'error',
      summary: 'Modifica utente',
      detail: result ? 'Utente modificato correttamente' : 'Modifica non andata a buon fine'
    })
    return !!result
  } catch (err) {
    window.growl.show({
      severity: 'error',
      summary: 'Errore',
      detail: err?.message || 'Modifica non andata a buon fine'
    })
    return false
  }
}

export const deleteUser = async (id, service) => {
  try {
    const result = await service.remove(id)
    window.growl.show({
      severity: result ? 'success' : 'error',
      summary: 'Eliminazione utente',
      detail: result ? 'Utente eliminato correttamente' : 'Eliminazione non andata a buon fine'
    })
    return !!result
  } catch (err) {
    window.growl.show({
      severity: 'error',
      summary: 'Errore',
      detail: err?.message || 'Eliminazione non andata a buon fine'
    })
    return false
  }
}
